import React, { useState } from 'react';
import { MapPin, Search, ArrowRight, Crosshair } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const LocationScreen = () => {
  const [address, setAddress] = useState('');
  const navigate = useNavigate();

  return (
    <div className="h-[calc(100vh-64px)] flex flex-col">
      {/* Map Section */}
      <div className="flex-1 bg-gray-100 relative">
        {/* Map Placeholder */}
        <div className="absolute inset-0 bg-gray-200">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
              <MapPin className="w-5 h-5 text-white" />
            </div>
          </div>
        </div>

        {/* GPS Location Button */}
        <button 
          onClick={() => {
            // Handle GPS location
            console.log('Locating user position...');
          }}
          className="absolute bottom-20 right-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50"
        >
          <Crosshair className="w-6 h-6 text-blue-600" />
        </button>
      </div>

      {/* Bottom Sheet */}
      <div className="bg-white rounded-t-3xl -mt-6 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] relative z-10 border-b border-gray-200">
        <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mt-3 mb-4"></div>
        
        {/* Content */}
        <div className="px-4 pb-4">
          {/* Title with promo */}
          <div className="bg-blue-100 rounded-xl p-3 mb-4 text-center">
            <span className="text-blue-800 font-medium">20% reducere pentru prima intervenție</span>
          </div>

          {/* Search Bar */}
          <div className="relative mb-4">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Unde ai nevoie de vulcanizare?"
              className="w-full pl-10 pr-4 py-3 bg-gray-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>

          {/* Help Button */}
          <button
            onClick={() => navigate('/details')}
            className="w-full bg-blue-600 text-white mt-4 py-4 rounded-xl font-medium hover:bg-blue-700 transition-colors flex items-center justify-center"
          >
            Solicita interventie
            <ArrowRight className="ml-2 w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationScreen;